import ModelViewer from '../components/ModelViewer';
import { GAME_BASE_HEAD_MODEL } from '../modelCatalog';
import './BlenderLab.css';

interface BlenderLabProps {
  onBack: () => void;
}

const HEAD_STUDY_CAMERA_TARGET: [number, number, number] = [0, 0.28, 0];

export default function BlenderLab({ onBack }: BlenderLabProps) {
  return (
    <div className="app blender-lab-page">
      <header className="app-header">
        <h1 className="app-title">Blender Character Lab</h1>
        <span className="app-subtitle">Studio Character Head</span>
        <div className="header-actions">
          <button className="nav-button" onClick={onBack} type="button">
            Car Viewer
          </button>
        </div>
      </header>

      <main className="blender-lab-viewer" data-testid="blender-lab">
        <ModelViewer
          ambientLightIntensity={0.82}
          autoRotate={false}
          background="#0e1016"
          cameraFov={40}
          cameraPosition={[0, 1.05, 5.0]}
          cameraTarget={HEAD_STUDY_CAMERA_TARGET}
          fillLightIntensity={0.82}
          fitSize={1.7}
          frontLightIntensity={0.85}
          groundY={-0.72}
          keyLightIntensity={0.96}
          maxDistance={6}
          minDistance={0.7}
          modelCount={1}
          modelPath={GAME_BASE_HEAD_MODEL}
          showContactShadows
          showGrid={false}
        />
      </main>
    </div>
  );
}
